import messages from '../../messages';

export const VALID_EGYPTIAN_NID_REGEX = /^\d{14}$/;

const validateNationalId = (value, formatMessage) => {
  const v = (value ?? '').trim();

  // Optional field: empty is OK
  if (!v) return '';

  // Must be exactly 14 digits
  if (!VALID_EGYPTIAN_NID_REGEX.test(v)) {
    return formatMessage
      ? formatMessage(messages['registration.national_id.validation.digits14'])
      : 'Enter a valid Egyptian National ID (14 digits)';
  }

  // 1st digit: century (2 = 1900s, 3 = 2000s)
  const century = v[0];
  if (century !== '2' && century !== '3') {
    return formatMessage
      ? formatMessage(messages['registration.national_id.validation.century'])
      : 'Invalid century digit in Egyptian National ID';
  }

  // YYMMDD must be a real date
  const yy = Number(v.slice(1, 3));
  const mm = Number(v.slice(3, 5));
  const dd = Number(v.slice(5, 7));
  const year = (century === '2' ? 1900 : 2000) + yy;

  if (mm < 1 || mm > 12 || dd < 1 || dd > 31) {
    return formatMessage
      ? formatMessage(messages['registration.national_id.validation.date'])
      : 'Invalid date in Egyptian National ID';
  }

  const d = new Date(year, mm - 1, dd);
  if (d.getFullYear() !== year || d.getMonth() + 1 !== mm || d.getDate() !== dd) {
    return formatMessage
      ? formatMessage(messages['registration.national_id.validation.date'])
      : 'Invalid date in Egyptian National ID';
  }

  return '';
};

export default validateNationalId;
